<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-right">
              <button
                type="button"
                v-if="checkedCustomers && checkedCustomers.length > 0"
                @click="showDeleteCustomersAlert()"
                class="btn btn-light font-18"
                style="float: left">
                <i class="far fa-trash-alt font-16 text-seconadry"></i>
              </button>

              <button
                type="button"
                class="btn bg-white search-box border-secondary rounded-5 mr-3"
                style="height: 42px">
                <a class="text-secondary waves-effect waves-dark p-0" href="javascript:void(0)">
                  <i class="fas fa-search font-16"></i>
                </a>
                <form class="app-search position-absolute" v-on:submit.prevent>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filterObj.search"
                    v-bind:placeholder="$lang.messages.search_enter"
                    v-on:keyup.enter="getList(1)"/>
                  <a class="srh-btn">
                    <i class="ti-close"></i>
                  </a>
                </form>
              </button>
              <button
                @click="clearAddModal"
                class="btn btn-primary px-4"
                data-toggle="modal"
                data-target="#AddCustomer">+ {{$lang.messages.add_customer}}</button>
            </div>

            <div class="card rounded-5">
              <div class="bg-white mt-3">
                <div class="pink-tape py-1">
                  <div class="row">
                    <div class="col-md-12 col-12 align-self-center pt-1">
                      <a
                        href="javascript:void(0)"
                        class="font-20 mb-0 text-regular text-hover-primary text-nowrap mr-4"
                        @click="getExport()">
                        {{$lang.messages.export}}
                        <i class="mdi mdi-download align-text-top"></i>
                      </a>
                    </div>
                    <div class="col-md-4 col-7 align-self-center text-right"></div>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col" width="40">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="spr_1"
                            ref="spr_1"
                            @change="checkAllcheckedCustomers($event)"
                          />
                          <label class="custom-control-label text-dark ml-2" for="spr_1"></label>
                        </div>
                      </th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'name')"
                      >{{$lang.messages.customer}}</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'email')"
                      >{{$lang.messages.email}}</th>
                      <th
                        scope="col"
                        class="sorting"
                        @click="sorting($event, 'phone_number')"
                      >{{$lang.messages.mobile_number}}</th>
                      <th scope="col">{{$lang.messages.address}}</th>
                      <th scope="col" class="sorting" @click="sorting($event, 'first_visit')">{{$lang.messages.first_visit}}</th>
                      <th scope="col" class="sorting" @click="sorting($event, 'last_visit')">{{$lang.messages.last_visit}}</th>
                      <th scope="col" class="sorting" @click="sorting($event, 'total_visit')">{{$lang.messages.total_visits}}</th>
                      <th scope="col" class="sorting" @click="sorting($event, 'total_spent')">{{$lang.messages.total_spent}}</th>
                      <th scope="col" class="text-right">{{$lang.messages.action}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,i) in list" :key="item.id">
                      <td style="min-width: 68px">{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td style="min-width: 30px">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="item.id"
                            :id="'type_'  +item.id"
                            v-model="checkedCustomers"
                            @change="checkUncheckCustomers($event)"
                          />
                          <label
                            class="custom-control-label text-dark ml-2"
                            :for="'type_' +item.id"
                          ></label>
                        </div>
                      </td>
                      <td>{{item.name}}</td>
                      <td>{{item.email}}</td>
                      <td v-if="item.phone_number">{{country_code}} {{item.phone_number}}</td>
                      <td v-else></td>
                      <td>
                        <div v-for="customer_address in item.customer_addresses" :key="customer_address.id">
                          <p style="margin-bottom: 0; min-width: 300px;">{{customer_address.address_label}}
                            <b v-if="customer_address.is_default" style="color: blue;">({{$lang.messages.default_address}})</b>
                          </p>
                          <p>{{customer_address.address}}</p>
                        </div>
                      </td>
                      <td v-if="item.first_visit">
                        {{item.first_visit | moment("DD MMM YYYY") }}
                        <br />
                        {{item.first_visit | moment("HH:mm") }}
                      </td>
                      <td v-else>-</td>
                      <td v-if="item.last_visit">
                        {{item.last_visit | moment("DD MMM YYYY") }}
                        <br />
                        {{item.last_visit | moment("HH:mm") }}
                      </td>
                      <td v-else>-</td>
                      <td v-if="item.total_visit">{{item.total_visit}}</td>
                      <td v-else>-</td>
                      <td v-if="item.total_spent">
                        <vue-numeric
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :value="item.total_spent"
                          :read-only="true"
                        />
                      </td>
                      <td v-else>-</td>
                      <td class="text-right pr-lg-4 text-nowrap">
                        <a
                          @click="setEditCustomer(item.id)"
                          href="javascript:void(0)"
                          data-toggle="modal"
                          data-target="#AddCustomer"
                          class="text-primary mr-2 font-18"
                        >
                          <i class="mdi mdi-pencil"></i>
                        </a>
                        <a
                          href="javascript:void(0)"
                          class="text-grey font-18"
                          data-toggle="modal"
                          data-target="#delete-customer-modal"
                          @click="setObj(item.id)"
                        >
                          <i class="far fa-trash-alt font-18 text-danger"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange"
                ref="customerPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="AddCustomer"
      tabindex="-1"
      role="dialog"
      aria-labelledby="AddCustomer"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md modal-lg" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5
              class="modal-title font-22"
            >{{customer.id ? $lang.messages.update_customer : $lang.messages.create_customer}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form @submit.prevent="validateBeforeSubmit">
            <div class="modal-body form-style" style="overflow-y: auto; height: 75vh;">
              <div class="row mb-4">
                <div class="col-lg-12 mb-4 modal-title font-18"><b>{{$lang.messages.personal_information}}</b></div>
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.name}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="name"
                    v-model="customer.name"
                    v-validate="'required|max:300'"
                    maxlength="300"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('name') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.name"
                  />
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('name')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_name}}</span>
                </div>

                <div class="col-lg-6 mb-4">
                  <label for>{{$lang.messages.email}}</label>
                  <input
                    name="email"
                    v-model="customer.email"
                    v-validate="'email'"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>

                <div class="col-lg-6 mb-4">
                  <label for>{{$lang.messages.mobile_number}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <label class="input-group-text" for="inputGroupSelect01">{{country_code}}</label>
                    </div>
                    <input
                      name="phone_number"
                      v-model="customer.phone_number"
                      class="input form-control"
                      v-validate="'required|numeric|min:7|notStartWithZero'"
                      :class="{'input': true, 'is-danger': errors.has('phone_number') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.mobile_number"
                    />
                  </div>
                  <i v-show="errors.has('phone_number')" class="fa fa-warning"></i>
                  <span v-if="customer.phone_number && customer.phone_number.startsWith('0', 0)"
                    v-show="errors.has('phone_number')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_phone_number}}</span>
                  <span v-else
                    v-show="errors.has('phone_number')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_10_digits_mobile_number}}</span>
                </div>

                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.note}}</label>
                  <label class="float-right">{{note_count}} / 300</label>
                  <textarea
                    rows="1"
                    :placeholder="$lang.messages.note"
                    style="height: auto"
                    class="form-control"
                    v-model="customer.notes"
                    maxlength="300"
                    v-on:keyup="changeNoteCount()"
                  ></textarea>
                </div>
              </div>
              <div id="listAddress" class="row">
                <div
                  class="mb-4"
                  v-for="(customer_address, index) in customer.customer_addresses"
                  :key="customer_address.id"
                  style="width: 100%">
                  <div class="col-lg-12 mb-4 modal-title font-18">
                    <b>{{$lang.messages.address_information}}</b>
                    <a style="float: right;"
                      href="javascript:void(0)"
                      @click="deleteAddressInformation(false, index)"
                      class="text-grey font-18">
                        <i class="far fa-trash-alt font-18 text-danger"></i>
                    </a>
                  </div>
                  <div class="col-lg-12 mb-4"><hr></div>
                  <div class="col-lg-12 mb-4 row" style="padding-right: 0; align-items: center;">
                    <div class="col-lg-6 col-6">
                      <label
                        for
                        class="font-18 text-dark"
                      >{{$lang.messages.make_this_address_default}}</label>
                    </div>
                    <div class="col-lg-6 col-6 text-right" style="padding-right: 0;">
                      <div class="form-group" style="margin-bottom: 0;">
                        <span class="switch switch-sm">
                          <input
                            type="checkbox"
                            class="switch"
                            :id="'is_default_' + index"
                            v-model="customer_address.is_default"
                            @change="changeDefaultAddress($event, index)"
                          />
                          <label :for="'is_default_' + index"></label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <label for>{{$lang.messages.address_label}}</label>
                    <span style="color:#ff0000">*</span>
                    <input
                      v-model="customer_address.address_label"
                      maxlength="300"
                      class="form-control"
                      :class="{'input': true }"
                      type="text"
                      v-bind:placeholder="$lang.messages.address_label_ex"
                    />
                  </div>
                  <div class="col-lg-12 mb-4">
                    <label for>{{$lang.messages.address_detail}}</label>
                    <span style="color:#ff0000">*</span>
                    <input
                      v-model="customer_address.address"
                      :class="{ 'form-control' : true, 'input': true }"
                      type="text"
                      v-bind:placeholder="$lang.messages.address_detail"
                    />
                  </div>
                  <div class="col-lg-12 mb-4 row" style="padding-right: 0;">
                    <div class="col-lg-6" style="padding-right: 0;">
                      <label for>{{$lang.messages.province}}</label>
                      <span style="color:#ff0000">*</span>
                      <select
                          v-model="customer_address.state"
                          class="form-control"
                          @change="getDistrictList(index)">
                        <option value disabled selected>{{$lang.messages.select_province}}</option>
                        <option
                          v-for="state in stateList"
                          :key="state.id"
                          :value="state"
                        >{{state.name}}</option>
                      </select>
                    </div>
                    <div class="col-lg-6" style="padding-right: 0;">
                      <label for>{{$lang.messages.city}}</label>
                      <span style="color:#ff0000">*</span>
                      <select v-model="customer_address.district"
                          class="form-control"
                          @change="getCityList(index)"
                          :disabled="!customer_address.districtList || customer_address.districtList.length==0">
                        <option value disabled selected>{{$lang.messages.select_city}}</option>
                        <option
                          v-for="city in customer_address.districtList"
                          :key="city.id"
                          :value="city"
                        >{{city.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4 row" style="padding-right: 0;">
                    <div class="col-lg-6" style="padding-right: 0;">
                      <label for>{{$lang.messages.district}}</label>
                      <span style="color:#ff0000">*</span>
                      <select v-model="customer_address.city"
                          class="form-control"
                          @change="getVillageList(index)"
                          :disabled="!customer_address.cityList || customer_address.cityList.length==0">
                        <option value disabled selected>{{$lang.messages.select_district}}</option>
                        <option
                          v-for="district in customer_address.cityList"
                          :key="district.id"
                          :value="district"
                        >{{district.name}}</option>
                      </select>
                    </div>
                    <div class="col-lg-6" style="padding-right: 0;">
                      <label for>{{$lang.messages.village}}</label>
                      <span style="color:#ff0000">*</span>
                      <select v-model="customer_address.village"
                          class="form-control"
                          :disabled="!customer_address.villageList || customer_address.villageList.length==0">
                        <option value disabled selected>{{$lang.messages.select_village}}</option>
                        <option
                          v-for="village in customer_address.villageList"
                          :key="village.id"
                          :value="village"
                        >{{village.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6 mb-4" style="padding-right: 0;">
                    <label for>{{$lang.messages.postal_or_zip_code}}</label>
                    <span style="color:#ff0000">*</span>
                    <input
                      type="text"
                      v-on:input="updatePostalCode($event, customer_address)"
                      :value="customer_address.postal_code"
                      :disabled="!!customer_address.village && !!customer_address.village.postal_code"
                      class="form-control input">
                  </div>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-lg-12">
                  <a
                    href="javascript:void(0)"
                    @click="addAnotherAddress()"
                    class="text-primary"
                  >
                    <i class="fas fa-plus-circle font-18 mr-2"></i>
                    {{$lang.messages.add_another_address.toUpperCase()}}
                  </a>
                </div>
              </div>

              <div class="col-lg-12 mb-4 mt-3" v-if="!customer_sharing">
                <div class="card rounded-5 pt-1 border">
                  <div
                    class="card-header bg-white border-bottom cursor-pointer px-lg-5 px-4"
                    data-toggle="collapse"
                    data-target=".stores-list"
                    aria-expanded="true"
                    aria-controls="multiCollapseExample1 multiCollapseExample2"
                  >
                    <h4 class="font-20 d-inline">
                      {{$lang.messages.store}}
                      <span
                        class="font-16 ml-3 d-inline"
                      >{{availableStoreStr}}</span>
                    </h4>
                    <img src="/images/down-arrow.svg" width="15" class="d-inline float-right mt-1" />
                  </div>
                  <div class="card-body form-style collapse stores-list px-lg-5 px-4 show">

                    <form @submit.prevent="searchStores($event)" class="mb-3">
                      <div class="input-group input-group-lg">
                        <span class="input-group-append">
                          <button class="btn btn-outline-secondary" type="submit" style="height: 40px;border-color: #c5c5c5;">
                              <i class="fa fa-search"></i>
                          </button>
                        </span>
                        <input
                            type="text"
                            class="form-control input-lg"
                            v-model="query"
                            v-on:input="searchStores($event)"
                            :placeholder="$lang.messages.search_store"/>
                      </div>
                    </form>

                    <div class="custom-control custom-checkbox" v-if="query == ''">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-1"
                        v-model="isAll"
                        @change="checkAllStores($event)"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-1"
                      >{{$lang.messages.customer_assigned_to_all_stores}}</label>
                    </div>
                    <div class="dropdown-divider" style="border-top: 1px solid #c3c3c3;" v-if="query == ''"></div>
                    <div>
                      <div
                        class="custom-control custom-checkbox mb-3"
                        v-for="store in storeList"
                        :key="store.id"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :value="store.id"
                          :id="'type_'  +store.id"
                          v-model="selectedStores"
                          @change="checkUncheckStore($event)"
                        />

                        <label
                          class="custom-control-label text-dark ml-2"
                          :for="'type_' +store.id"
                        >{{store.name}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 justify-content-center">
              <button
                type="submit"
                class="btn btn-primary mr-3"
                id="save-btn"
              >{{$lang.messages.save_btn_text}}</button>

              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-primary"
                id="cancel-btn"
              >{{$lang.messages.cancel_btn_text}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Alert
      @rightButtonEvent="deleteSelectedCustomer($event)"
      v-bind:title="$lang.messages.delete_customer"
      ref="deleteMultipleCustomerAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-multiple-customer-modal"
    />

    <Alert
      @rightButtonEvent="deleteAddressInformation(true)"
      v-bind:title="$lang.messages.delete_address_information"
      ref="deleteAddressInformationAlert"
      tabindex="-2"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-address-infor-modal"
    />

    <a
      data-toggle="modal"
      data-target="#delete-multiple-customer-modal"
      ref="deleteMultipleCustomerLink"
      style="display: none"
    />

    <Alert
      @rightButtonEvent="deleteCustomer($event)"
      v-bind:title="$lang.messages.delete_customer"
      ref="deleteCustomerAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-customer-modal"
    />
    <Alert
      @rightButtonEvent="saveDuplicatedName($event)"
      v-bind:title="$lang.messages.duplicated_customer_data"
      ref="duplicatedItemAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="duplicated-customer-modal"
    />
    <Alert
      @rightButtonEvent="saveNoneCustomerStore($event)"
      v-bind:title="$lang.messages.customer"
      ref="noneCustomerStore"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="none-customer-store-modal"
    />
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import EventBus from "@/eventBus";
import accessible from '@/mixins/accessible'

var initialAddressInfor = {
  address_label: "",
  address: "",
  districtList: [],
  cityList: [],
  villageList: [],
  is_default: false,
  postal_code: "",
  postal_code_origin: ""
};

export default {
  name: "Customers",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      customer_sharing: false,
      checkedCustomers: [],
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      country_code: "",
      decimal_separator: ".",
      precision: 0,
      customer: {
        id: "",
        email: "",
        name: "",
        phone_number: "",
        notes: "",
        ignore_duplicated: false,
        force_allow_none_store: false,
        customer_addresses: [
          {
            ...initialAddressInfor,
            is_default: true
          }
        ]
      },
      list: [],
      note_count: 0,
      currentSorting: "",
      filterObj: {
        sort_by: "",
        order_by: "desc",
        search: ""
      },
      stateList: [],
      deletedAddressIndex : 0,
      storeList: [],
      selectedStores: [],
      stores: [],
      availableStoreStr: "",
      query: "",
      storeListOrigin: [],
      isAll: false,
      duplicatedMessage: "",
    };
  },

  mixins: [accessible],

  methods: {
    updatePostalCode($event, customer_address) {
      customer_address.postal_code_origin = $event.target.value
    },
    inProgress() {
      alert("In progress");
    },
    checkAllcheckedCustomers(event) {
      this.checkedCustomers = [];
      if (event.target.checked) {
        for (var i = 0; i < this.list.length; i++) {
          this.checkedCustomers.push(this.list[i].id);
        }
      }
    },
    checkUncheckCustomers() {
      if (this.$refs.spr_1) {
        if (
          this.checkedCustomers.length > 0 &&
          this.checkedCustomers.length == this.list.length
        ) {
          this.$refs.spr_1.checked = true;
        } else {
          this.$refs.spr_1.checked = false;
        }
      }
    },
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.customerPagination.itemsPerPage;
      this.getList(1);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.add();
          return;
        }
      });
    },
    clearAddModal(e) {
      if (!this.checkPendingAccountStatus(e)) return

      this.customer.id = "";
      this.customer.name = "";
      this.customer.email = "";
      this.customer.phone_number = "";
      this.customer.notes = "";
      this.customer.customer_addresses = [
        {
          ...initialAddressInfor,
          is_default: true
        }
      ];
      this.note_count = 0;
      this.$validator.reset();
      this.errors.clear();
      this.checkAllStores();
    },
    showDeleteCustomersAlert() {
      this.$refs.deleteMultipleCustomerLink.click();
      this.$refs.deleteMultipleCustomerAlert.message = this.$lang.messages.delete_multiple_customers_message;
    },
    deleteSelectedCustomer() {
      for (var i = 0; i < this.checkedCustomers.length; i++) {
        this.$api
          .deleteAPI({
            _action: "/customer/delete/" + this.checkedCustomers[i]
          })
          .then(res => {
            if (i == this.checkedCustomers.length) {
              this.getList(1);
              this.checkedCustomers = [];
              this.$refs.spr_1.checked = false;
              this.$refs.deleteMultipleCustomerAlert.close();
              this.$notify({
                group: "foo",
                text: this.$lang.messages.deleted_successfully,
                type: "success"
              });
            }
          })
          .catch(e => {
            this.getList();
          });
      }
    },
    setObj(id) {
      this.customer.id = id;
      this.$refs.deleteCustomerAlert.message = this.$lang.messages.are_you_sure_you_want_to_delete_the_customer;
    },
    deleteCustomer(e) {
      if (this.customer.id) {
        this.$api
          .deleteAPI({
            _action: "/customer/delete/" + this.customer.id
          })
          .then(res => {
            this.$refs.deleteCustomerAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            this.customer.id = "";
            this.getList(1);
          })
          .catch(e => {
            this.$refs.deleteCustomerAlert.close();
          });
      }
    },
    setEditCustomer(id) {
      this.details(id);
      $("#AddCustomer").modal("show");
    },

    details(id) {
      this.customer = {};
      this.$api
        .getAPI({
          _action: "/customer/detail/" + id
        })
        .then(res => {
          if (res.stores && res.stores.length > 0) {
            this.selectedStores = []
            for (var i = 0; i < res.stores.length; i++) {
              if (res.stores[i].is_available) this.selectedStores.push(res.stores[i].store_id);
            }
            if (this.selectedStores.length == this.storeList.length) {
              this.isAll = true;
            }
          } else {
            this.selectedStores = [];
            this.isAll = false;
          }
          this.setAvailableStr();

          res.customer_addresses = res.customer_addresses.map(
            it => {
              if (it.state)
                it.state = this.stateList.find(
                  state => it.state.id == state.id );
              it.districtList = [];
              it.cityList = [];
              it.villageList = [];
              return it;
            }
          );

          this.customer = res;
          if (this.customer.notes) {
            this.note_count = this.customer.notes.length;
          }
          this.customer.customer_addresses.map((_, i) => {
            this.getDistrictList(i);
            this.getCityList(i);
            this.getVillageList(i);
          });
        });
    },
    changeNoteCount() {
      if (this.note_count >= 300) {
        this.customer.notes = this.customer.notes.substring(0, 300);
        this.note_count = 300;
      }
      this.note_count = this.customer.notes.length;
    },
    retry() {
      this.getList(1);
    },
    getList(page, sortBy, orderBy) {
      this.list = [];
      this.checkedCustomers = [];

      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }


      this.$api
        .getAPI({
          _action: "/customer/list/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            for (let i = 0; i < res.list.length; i++){
              res.list[i].address = res.list[i].customer_addresses.map(customer_address => {
                if (customer_address.village){
                  customer_address.address += `, ${customer_address.village.name}`;
                }
                if (customer_address.city){
                  customer_address.address += `, ${customer_address.city.name}`;
                }
                if (customer_address.district){
                  customer_address.address += `, ${customer_address.district.name}`;
                }
                if (customer_address.state){
                  customer_address.address += `, ${customer_address.state.name}`;
                }
                if (customer_address.postal_code){
                  customer_address.address += `, ${customer_address.postal_code}`;
                }
                if (customer_address.address !== ""){
                  customer_address.address += "."
                }
                return `${customer_address.address}`;
              }).join("\n\n");
            }

            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.customerPagination.setTotalCount(res.count);
            } else {
              this.$refs.customerPagination.setTotalCount(0);
            }
          }
          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_customers_found
            );
          } else {
            if (this.$refs.errorComonent.isShowMessage()) {
              this.$refs.errorComonent.setTitle();
            } else {
              this.checkUncheckCustomers();
            }
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    getExport() {
      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/customer/export_customer/" +
          localStorage.getItem("client_id") +
          queryParam
        , _fileName: 'customers.csv'})
    },
    add() {
      if (this.selectedStores.length > 0) {
        this.customer.stores = this.selectedStores;
      } else {
        this.customer.stores = [];
      }

      if (!this.customer.value) {
        this.customer.value = 0;
      }

      var data = JSON.parse(JSON.stringify(this.customer));
      data.customer_addresses = data.customer_addresses.filter(
        it => {
          return JSON.stringify(it) != JSON.stringify(initialAddressInfor);
        }
      ).map(
        it => {
          delete it.stateList;
          delete it.districtList;
          delete it.cityList;
          delete it.villageList;
          return it;
        }
      );
      this.$api
        .postAPI({
          _action: "/customer/save",
          _body: data,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          document.getElementById("cancel-btn").click();
          this.getList(1);
        })
        .catch(e => {
            if (e.status == 409){
              this.$refs.duplicatedItemAlert.message = e.data.message;
              $('#duplicated-customer-modal').modal('show');
            }
            if (e.status == 406){
              this.$refs.noneCustomerStore.message = e.data.message;
              $('#none-customer-store-modal').modal('show');
            }
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },
    addAnotherAddress(){
      this.customer.customer_addresses.push(
        {
          ...initialAddressInfor
        }
      );
    },
    getStateList() {
      if (localStorage.getItem("country_id")) {
        this.$api
          .getAPI({
            _action: "/state/list/" + localStorage.getItem("country_id")
          })
          .then(res => {
            this.stateList = res.list;
          })
          .catch(e => {});
      }
    },
    getDistrictList(index) {
      if (this.customer.customer_addresses[index].state) {
        this.$api
          .getAPI({
            _action: "/district/list/" + this.customer.customer_addresses[index].state.id
          })
          .then(res => {
            this.customer.customer_addresses[index].districtList = res.list;
            this.customer.customer_addresses[index].district = res.list.find(
              district => district.id == this.customer.customer_addresses[index].district.id )
          })
          .catch(e => {});
        this.customer.customer_addresses[index].cityList = [];
        this.customer.customer_addresses[index].villageList = [];
      }
    },
    getCityList(index) {
      if (this.customer.customer_addresses[index].district) {
        this.$api
          .getAPI({
            _action: "/city/list/" + this.customer.customer_addresses[index].district.id
          })
          .then(res => {
            this.customer.customer_addresses[index].cityList = res.list;
            this.customer.customer_addresses[index].city = res.list.find(
              city => city.id == this.customer.customer_addresses[index].city.id )
          })
          .catch(e => {});
        this.customer.customer_addresses[index].villageList = [];
      }
    },
    getVillageList(index) {
      if (this.customer.customer_addresses[index].city) {
        this.$api
          .getAPI({
            _action: "/village/list/" + this.customer.customer_addresses[index].city.id
          })
          .then(res => {
            this.customer.customer_addresses[index].villageList = res.list;
            this.customer.customer_addresses[index].village = res.list.find(
              village => village.id == this.customer.customer_addresses[index].village.id )
          })
          .catch(e => {});
      }
    },
    changeDefaultAddress(event, index){
      this.customer.customer_addresses = this.customer.customer_addresses.map( (customer_address, i) => {
        customer_address.is_default = (i == index && event.target.checked);
        return customer_address;
      });
    },
    deleteAddressInformation(force=false, index=this.deletedAddressIndex) {
      if (force || JSON.stringify(this.customer.customer_addresses[index]) == JSON.stringify(initialAddressInfor)) {
        this.customer.customer_addresses.splice(index, 1);
        this.$refs.deleteAddressInformationAlert.close();
      } else {
        this.deletedAddressIndex = index;
        this.$refs.deleteAddressInformationAlert.message = this.$lang.messages.are_you_sure_you_want_to_delete_this_address_information;
        $("#delete-address-infor-modal").modal('show');
      }
    },
    searchStores(event) {
      if(this.query == ""){
        this.storeList = this.storeListOrigin
      }else{
        this.storeList = this.$flowFilter(this.storeListOrigin, this.query);
      }
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
            this.storeListOrigin = res.list;
            this.checkAllStores();
          }
        })
        .catch(e => {});
    },
    checkAllStores(event) {
      this.availableStoreStr = "";
      if (this.isAll) {
        for (var i = 0; i < this.storeList.length; i++) {
          if(this.selectedStores.indexOf(this.storeList[i].id) == -1){
            this.selectedStores.push(this.storeList[i].id);
          }
        }
      }else{
        for (var i = 0; i < this.storeList.length; i++) {
          this.selectedStores = this.selectedStores.filter(item => item !== this.storeList[i].id)
        }
      }
      this.setAvailableStr();
    },

    setAvailableStr() {
      this.availableStoreStr = "";
      var nAvailableStore = 0;
      for(let i=0; i<this.selectedStores.length; i++){
        if(this.$_.findIndex(this.storeListOrigin, {'id': this.selectedStores[i]}) != -1){
          nAvailableStore += 1
        }
      }
      this.isAll = false
      if(nAvailableStore == this.storeListOrigin.length){
        this.isAll = true
      }
      if (this.selectedStores.length > 0) {
        if (this.isAll) {
          this.availableStoreStr = this.$lang.messages.customer_assigned_to_all_stores;
        } else {
          if (nAvailableStore == 1) {
            this.availableStoreStr = `${this.$lang.messages.customer_assigned_to} 1 ${this.$lang.messages.store.toLowerCase()}`;
          } else if(nAvailableStore > 0) {
            this.availableStoreStr = `${this.$lang.messages.customer_assigned_to} ${nAvailableStore} ${this.$lang.messages.store.toLowerCase()}`;
          }
        }
      }
    },
    checkUncheckStore(event) {
      this.setAvailableStr();
      if (event && !event.target.checked) {
        this.isAll = false;
      }
    },
    saveDuplicatedName(e){
      this.customer.ignore_duplicated = true
      this.$refs.duplicatedItemAlert.close();
      this.add()
    },

    saveNoneCustomerStore(e){
      this.customer.force_allow_none_store = true
      this.$refs.noneCustomerStore.close();
      this.add()
    },
  },

  mounted() {
    this.country_code = localStorage.getItem("country_code");
    this.customer_sharing = (localStorage.getItem("customer_sharing") || "") == "true";
    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );

    this.getList(1);
    this.getStateList();
    this.getStoreList();
    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
    this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;

    // get current user data
    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.currentUser = payload
    });
  },
  created() {
  this.$validator.extend('notStartWithZero',{
     validate: (value) => {
       if (!value.startsWith('0', 0)) return true;
       return false;
     }
  });
},
  watch: {
    customer: {
      handler(newVal) {
          if(!!newVal.customer_addresses) {
              for (let i = 0; i < newVal.customer_addresses.length; i++) {
                  if(newVal.customer_addresses[i].village && !!newVal.customer_addresses[i].village.postal_code){
                    newVal.customer_addresses[i].postal_code = newVal.customer_addresses[i].village.postal_code
                  }else{
                      if(!newVal.customer_addresses[i].postal_code_origin){
                        newVal.customer_addresses[i].postal_code = ""
                      }else{
                        newVal.customer_addresses[i].postal_code = newVal.customer_addresses[i].postal_code_origin
                      }
                  }
              }

          }

      }, deep: true
    }
  }
};
</script>
